import React from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ListItemText from '@mui/material/ListItemText';
import StorageIcon from '@mui/icons-material/Storage';
import Person2Icon from '@mui/icons-material/Person2';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { styled } from '@mui/system';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { useHistory } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Typography } from '@mui/material';

const theme = createTheme({

});
const CustomLink = styled(Link)({
  textDecoration: 'none',
  color: 'inherit',
  '&:focus, &:active': {
    outline: 'none',
    textDecoration: 'none',
  },
});
const SideBar = () => {
  const history = useHistory();
  const [userName, setUserName] = useState(''); // Placeholder for username, can be fetched from API
  
  useEffect(() => {
    // fetch user data from local storage
    const user_data = localStorage.getItem('user');
    if (user_data) {
      const user = JSON.parse(user_data);
      setUserName(user.first_name + ' ' + user.last_name || ''); // Default to empty string if not available
    }
  }, []);



  // if no local storage token, dont display any fields 
  const handleLogout = () => {
    localStorage.removeItem('token'); // Clear the token from localStorage
    window.location.href = '/login'; // Force a full page reload to the login page
  };
  const token = localStorage.getItem('token');
  if (!token) {
    return <List sx={{ backgroundColor: 'rgb(78, 33, 87)', color: 'white', height: '100vh',boxShadow:'0px 5px 2px 2px grey', }}>
          
        </List>; // or return a placeholder component
  }
  return (

        <List sx={{ backgroundColor: 'rgb(78, 33, 87)', color: 'white', height: '100vh',boxShadow:'0px 5px 2px 2px grey', }}>
          <ListItem button  to="/view-profile">
            <ListItemIcon>
              <Person2Icon sx={{color:'white'}}/>
            </ListItemIcon>
            <ListItemText primary={userName}/>
          </ListItem>
          <ListItem button component={CustomLink} to="/">
            <ListItemIcon>
              <DashboardIcon sx={{color:'white'}}/>
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
          <ListItem button component={CustomLink}  to="/jobs/all">
            <ListItemIcon>
              <AddBoxIcon sx={{color:'white'}}/>
            </ListItemIcon>
            <ListItemText primary="Outstanding Audits" />
          </ListItem>
          <ListItem button  component={CustomLink} to="/view-all-audits">
            <ListItemIcon>
              <StorageIcon sx={{color:'white'}}/>
            </ListItemIcon>
            <ListItemText primary="View All Audits" />
          </ListItem>
          <ListItem button  onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon sx={{color:'white', cursor:'pointer'}}/>
            </ListItemIcon>
            <ListItemText primary="Logout" sx={{color:'white', cursor:'pointer'}}/>
          </ListItem>
          <Typography variant="body2" sx={{ color: 'white', position: 'absolute', bottom: 100 , left: 16 }}>
            Version 2.0.1
          </Typography>
        </List>
        
        // version number at the bottom 
  );
};

export default SideBar;